export const SAVE_PLATFORMS = 'savePlatforms'
export const SELECTED_FILE = 'selectedFile'